import * as React from "react";
import {cx} from "emotion";

import "./default-radius-list-quantities.scss";

import {cs}                             from "@Common/react/chain-services";
import {consumeContext}                 from "@Common/react/context";
import {keyed}                          from "@Common/react/keyed";
import {getNestedValue, setNestedValue} from "@Common/utils/arr-path";
import {omit}                           from "@Common/utils/objects";

import {FlexNumberInput} from "./flex-number-input/flex-number-input";

export const DefaultRadiusListQuantities = (
    {
        programPrefs,
        product,
        store,
        mailing,
        className,
    }
) => cs(
    () => (
        <div className={cx("default-radius-list-quantities-6fq", className)}>
            <div className="header">
                <div className="label">
                    {mailing ? (
                        "Default Radius List Quantities"
                    ) : (
                        "Default Quantities"
                    )}
                </div>
            </div>

            <div className="table">
                {[
                    {
                        label: "New Listing",
                        name: "newListing",
                    },
                    {
                        label: "Price Change",
                        name: "priceChange",
                    },
                    {
                        label: "Open House",
                        name: "openHouse",
                    },
                    {
                        label: "Sold",
                        name: "sold",
                    },
                ].map(({label, name}, i) => cs(
                    keyed(i),
                    consumeContext("apis"),
                    ({apis}) => (
                        <div className="line">
                            <div className="label">
                                {label}
                            </div>
                            <div className="value">
                                {(() => {
                                    const path = ["products", product, "quantities", name];
                                    // console.log("store.prefs", store.prefs);
                                    return FlexNumberInput({
                                        value: getNestedValue(store.prefs, path) ?? getNestedValue(programPrefs, path),
                                        onChange: async (newValue) => {
                                            await store.dispatch(saveQuantity(newValue, {path, apis}));
                                            // console.log("Blah", newValue);
                                            // await waitTimeout(1000);
                                        },
                                    });
                                })()}
                            </div>
                        </div>
                    ),
                ))}
            </div>
        </div>
    ),
);

const saveQuantity = (newValue, {path, apis}) => ({
    action: async (data) => {
        const newData = setNestedValue(omit(data, ["error"]), path, newValue);
        await apis.listings.saveCleanUserPrefs(newData);
        return {
            change: () => newData,
        };
    },
});
